import moment from "moment"
import { createSelector } from "reselect"
import { get } from "lodash"

const getFeatures = state => get(state, "modules.newFeature.features")
const getId = (_, props) => props.id

export const EXPIRED_FEATURES = {
  "factors-view": moment().isAfter("2022-12-20"),
}

export const getSeen = createSelector(
  [getFeatures, getId],
  (features, id) => get(features, [id, "seen"], false),
)

export const getExpired = createSelector(
  [getId],
  (id) => get(EXPIRED_FEATURES, id),
)
